import { NetworkClient, useClassFactory, useNetworkService } from "@pasta/box-v2";
import { type AcceptedDto, type UploadedFileDto, type UploadUsage } from "../dto/file.dto";

const UPLOAD_ROUTES: Record<UploadUsage, string> = {
  "upload-document": "upload/document",
  "upload-signature": "upload/signature",
  "upload-audio": "upload/audio",
};

export class FileApi {
  protected readonly baseEndpoint = "file/";

  protected get network(): NetworkClient {
    return useNetworkService();
  }

  /** one upload route per usage, see parapheur-back files/controllers/upload.controller.ts */
  async uploadFile(form: FormData, usage: UploadUsage): Promise<UploadedFileDto> {
    const response = await this.network.post(UPLOAD_ROUTES[usage], form);
    return response.data;
  }

  async createLink(object: string) {
    const response = await this.network.post<{ link: string; token: string }>(
      `${this.baseEndpoint}link`,
      {},
      { params: { object } }
    );
    return response.data;
  }

  async getLink(token: string, asAttachment: boolean = false) {
    const response = await this.network.get<string>(`${this.baseEndpoint}link`, {
      token,
      asAttachment,
    });
    return response.data;
  }

  async getAccepted(): Promise<AcceptedDto> {
    const response = await this.network.get(`${this.baseEndpoint}accepted`);
    return response.data;
  }
}

export const [fileApiToken, useFileApi] = useClassFactory(FileApi);
